import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Mail } from '../dto/mail';

@Injectable()
export class MailService {

    constructor(private http: HttpClient) { }

    sendMail(mail: Mail): Observable<any> {
        return this.http.post(`/api/mail/SendMail`, mail);
    }
}